// extracted by mini-css-extract-plugin
export default {"BannerShop":"BannerShop-module--BannerShop--0b877","BannerShop__text":"BannerShop-module--BannerShop__text--9ce23"};